import React from 'react';
import './Shop.css';
import img1 from '../../images/products/product-details.jpg';
import img2 from '../../images/products/product-1.jpg';
import img3 from '../../images/products/product-2.jpg';
import img4 from '../../images/products/product-3.jpg';
import img5 from '../../images/products/product-5.jpg';

const Shop = () => {
    return (
        <div id="shop">
            <h1 className="fs-1 text-center my-5">Products Details</h1>
            <div className="shop-container">
                <div>
                    <img src={img1} alt="" />
                </div>
                <div className="shop-detail">
                    <h1>Sunglass</h1>
                    <p className="my-5">Cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odios Suspe ndisse cursus mal suada faci lisis. Lorem ipsum dolor.ipsum dolor sit amet,.Lorem ipsum dolor.ipsum dolor sit amet, cons ectetur elit. Ves tibulum nec odio</p>
                    <h5 className="mb-5">Price: $180.00</h5>
                    <h5 className="mb-5">Quantity:
                         <input className="input" value="1" type="number" />
                    </h5>
                    <button className="button">Add to Cart</button>
                </div>
            </div>
            <h1 className="fs-1 text-center my-5">Related Products</h1>
            <div className="product-container">
                <div className="product">
                    <img src={img3} alt="" />
                    <h3 className="my-2">Summer Hat</h3>
                    <div className="cartIcon">
                        <p>Price: $80.00</p>
                        <i className="fs-5 addIcon fas fa-cart-plus"></i>
                    </div>
                </div>
                <div className="product">
                    <img src={img2} alt="" />
                    <h3 className="my-2">BackPak</h3>
                    <div className="cartIcon">
                        <p>Price: $180.00</p>
                        <i className="fs-5 addIcon fas fa-cart-plus"></i>
                    </div>
                </div>
                <div className="product">
                    <img src={img4} alt="" />
                    <h3 className="my-2">Sunglass</h3>
                    <div className="cartIcon">
                        <p>Price: $132.00</p>
                        <i className="fs-5 addIcon fas fa-cart-plus"></i>
                    </div>
                </div>
                <div className="product">
                    <img src={img5} alt="" />
                    <h3 className="my-2">Flip-Flops</h3>
                    <div className="cartIcon">
                        <p>Price: $90.00</p>
                        <i className="fs-5 addIcon fas fa-cart-plus"></i>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Shop;